module.exports = __webpack_public_path__ + "static/media/3.9e05612e.png";